export default {
  order: 8,
  name: "Attendance",
  icon: "mdi-check-all",
  to: "/attendance",
  enabled: true,
};
